import { render } from "./UpdatePwd.vue?vue&type=template&id=21c855d3&ts=true"
import script from "./UpdatePwd.vue?vue&type=script&lang=ts"
export * from "./UpdatePwd.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__